import type { RouteObject } from 'react-router-dom';
import { lazyElement } from '../routing/lazyRoute';

const changelogRoutes: RouteObject[] = [
  {
    path: '/changelog',
    element: lazyElement(() => import('./Changelog')),
    handle: {
      documentTitle: 'Changelog',
      crumb: () => ({ label: 'Changelog', to: '/changelog' })
    },
  },
];

export default changelogRoutes;
